import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { Button } from "./landing";
import { forwardRef } from "react";
import { Listbox } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import classNames from "classnames";
import { useRouter } from "next/router";
import { PlusIcon } from "@heroicons/react/outline";
/**
 * Needs to have orgId param in query
 */ export var Select = /*#__PURE__*/ forwardRef(function(param, ref) {
    var onChange = param.onChange, value = param.value, _endButton = param.endButton, endButton = _endButton === void 0 ? null : _endButton, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Loading" : _placeholder, options = param.options, _className = param.className, className = _className === void 0 ? "" : _className, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _useAutoGradientIcons = param.useAutoGradientIcons, useAutoGradientIcons = _useAutoGradientIcons === void 0 ? false : _useAutoGradientIcons;
    var router = useRouter();
    var orgId = router.query.orgId || "";
    var hoverClasses = "hover:bg-gray-100 hover:dark:bg-gray-600 rounded mx-2";
    var current = options.find(function(x) {
        return x.value === value;
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Listbox, {
            value: orgId,
            onChange: onChange,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "jsx-cf56417ef7cbaa5a" + " " + (classNames("relative") || ""),
                children: [
                    /*#__PURE__*/ _jsxs(Listbox.Button, {
                        ref: ref,
                        as: "button",
                        className: classNames("relative w-full py-[8px] pl-3 pr-10 text-left bg-white rounded-lg shadow-sm shadow border dark:bg-gray-700 focus:outline-none focus-visible:ring-1 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-gray-300 focus-visible:ring-offset-1 sm:text-sm", className),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                "aria-label": "current org",
                                className: "jsx-cf56417ef7cbaa5a" + " " + "flex items-center space-x-2 truncate font-medium",
                                children: [
                                    useAutoGradientIcons && /*#__PURE__*/ _jsx(GradientIcon, {
                                        name: isLoading ? "" : (current === null || current === void 0 ? void 0 : current.name) || (current === null || current === void 0 ? void 0 : current.value)
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "jsx-cf56417ef7cbaa5a" + " " + "",
                                        children: isLoading ? "Loading" : (current === null || current === void 0 ? void 0 : current.name) || placeholder
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "jsx-cf56417ef7cbaa5a" + " " + "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                children: /*#__PURE__*/ _jsx(SelectorIcon, {
                                    className: "w-5 h-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    _jsx(_JSXStyle, {
                        id: "cf56417ef7cbaa5a",
                        children: "@-webkit-keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-moz-keyframes menuAppear{from{opacity:0;-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-o-keyframes menuAppear{from{opacity:0;transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}"
                    }),
                    /*#__PURE__*/ _jsx(Faded, {
                        animationName: "menuAppear",
                        duration: 120,
                        cascade: true,
                        children: /*#__PURE__*/ _jsxs(Listbox.Options, {
                            className: classNames("absolute z-50 gap-2 flex flex-col w-full py-2 mt-1 overflow-auto text-base bg-white rounded-md shadow-xl dark:bg-gray-700 max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"),
                            children: [
                                options === null || options === void 0 ? void 0 : options.map(function(opt, idx) {
                                    /*#__PURE__*/ return _jsx(Listbox.Option, {
                                        className: function(param) {
                                            var active = param.active;
                                            return classNames("cursor-pointer select-none relative py-[6px] pr-10 ", opt.value === value && "bg-gray-100 dark:bg-gray-600", hoverClasses);
                                        },
                                        value: opt.value,
                                        children: function(param) {
                                            var selected = param.selected, active = param.active;
                                            /*#__PURE__*/ return _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "jsx-cf56417ef7cbaa5a" + " " + (classNames("flex items-center space-x-2 pl-2 truncate font-medium") || ""),
                                                        children: [
                                                            useAutoGradientIcons && /*#__PURE__*/ _jsx(GradientIcon, {
                                                                name: (opt === null || opt === void 0 ? void 0 : opt.name) || (opt === null || opt === void 0 ? void 0 : opt.value)
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "jsx-cf56417ef7cbaa5a" + " " + "text-sm",
                                                                children: opt.name || opt.value
                                                            })
                                                        ]
                                                    }),
                                                    selected ? /*#__PURE__*/ _jsx("span", {
                                                        className: "jsx-cf56417ef7cbaa5a" + " " + (classNames("absolute inset-y-0 right-1 flex items-center pl-3", active ? "text-amber-600" : "text-amber-600") || ""),
                                                        children: /*#__PURE__*/ _jsx(CheckIcon, {
                                                            className: "w-5 h-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null
                                                ]
                                            });
                                        }
                                    }, opt.value);
                                }),
                                endButton
                            ]
                        })
                    })
                ]
            })
        })
    });
});
Select.SelectButton = SelectButton;
function SelectButton(_param) {
    var className = _param.className, children = _param.children, rest = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    var hoverClasses = "hover:bg-gray-100 hover:dark:bg-gray-600 rounded mx-2";
    return /*#__PURE__*/ _jsxs("button", _object_spread_props(_object_spread({
        className: classNames("flex space-x-2 py-[5px] pl-2 text-left items-center font-medium text-sm", hoverClasses, className)
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(PlusIcon, {
                className: "w-4 h-4 mx-px"
            }),
            /*#__PURE__*/ _jsx("div", {
                children: children
            })
        ]
    }));
}
import ColorHash from "color-hash";
import { colord, extend } from "colord";
import mixPlugin from "colord/plugins/mix";
import harmoniesPlugin from "colord/plugins/harmonies";
import { Faded } from "baby-i-am-faded";
extend([
    mixPlugin,
    harmoniesPlugin
]);
var colorHash = new ColorHash({
    lightness: 0.6
});
function GradientIcon(param) {
    var name = param.name;
    var width = 18;
    var background = function() {
        if (!name) {
            return "#aaa";
        }
        var color = colorHash.hex(name);
        var ref = _sliced_to_array(colord(color).harmonies("analogous"), 2), first = ref[0], second = ref[1];
        return "linear-gradient(to right, ".concat(first.toHex(), ", ").concat(second.desaturate(0.3).toHex(), ")");
    }();
    return /*#__PURE__*/ _jsx("div", {
        style: {
            background: background,
            width: width,
            height: width
        },
        className: "rounded-md shrink-0 "
    });
}
